import { TextField, SxProps, Theme } from '@mui/material'
import { useEffect, useRef } from 'react'
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form'
import { assembleValidations } from '~utils/form-validations'

interface TextInputFieldProps {
  name: string
  label?: string
  defaultValue?: string | null
  focus?: boolean
  placeholder?: string
  required?: boolean
  disabled?: boolean
  type?: 'text' | 'password'
  validations?: RegisterOptions
  className?: string
  sx?: SxProps<Theme>
  multiline?: boolean
  minRows?: number
  maxRows?: number
}

export const TextInputField = ({
  name,
  defaultValue,
  disabled,
  validations,
  required,
  placeholder,
  label,
  focus,
  className,
  type = 'text',
  sx,
  multiline,
  minRows,
  maxRows,
}: TextInputFieldProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (focus) {
      inputRef?.current?.focus()
    }
  }, [focus])

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={assembleValidations(required, validations)}
      render={({ field: { onChange, value, ref } }) => {
        return (
          <TextField
            inputRef={(el) => {
              ref(el)
              inputRef.current = el
            }}
            name={name}
            type={type}
            value={value ?? ''}
            placeholder={placeholder}
            className={className}
            onChange={onChange}
            disabled={disabled}
            label={label}
            required={required}
            error={!!errors[name]}
            helperText={errors[name]?.message as string}
            size="small"
            fullWidth
            sx={sx}
            multiline={multiline}
            minRows={minRows}
            maxRows={maxRows}
          />
        )
      }}
    />
  )
}
